import { render } from "./button-full-video.vue?vue&type=template&id=54f2ec40&scoped=true"
import script from "./button-full-video.vue?vue&type=script&lang=js"
export * from "./button-full-video.vue?vue&type=script&lang=js"

import "./button-full-video.vue?vue&type=style&index=0&id=54f2ec40&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f2ec40"]])

export default __exports__